// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue-main: #0A3760;
  --blue-light: #1B5D9B;
  --border: #e5e7eb;
  --shadow: 0 4px 18px rgba(0,0,0,.06);
}

/* Page layout: sessions stacked with gap */
.summary-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Row holding Session 1 & 2 side by side */
.sum-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  align-items: stretch;
}

/* Each session container */
.sum-section {
  width: 100%;
}

/* Make toolbar session content align to bottom */
.sum-section.session-toolbar {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

/* Ensure session 3 spans full width */
.sum-section--full {
  width: 100%;
}

/* ---------------------------
   Widgets (Session 1)
---------------------------- */
.sum-widgets {
  display: flex;
  flex-direction: row;
  gap: 24px;          /* narrower gap between widgets */
  justify-content: flex-start; /* align to left */
  align-items: center;
  padding-left: 8px;  /* reduce left space */
  padding-right: 0;
  padding-top: 6px;
  padding-bottom: 6px;
}


.widget {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;              /* spacing between icon & text */
  background: transparent;
  box-shadow: none;
  border: none;
  border-radius: 10px;
  padding: 4px 8px;
  text-align: left;
  min-width: 260px;
}

.widget-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #e9f1fb;
  color: #0F5499;
  font-size: 24px;
  flex-shrink: 0;
}

.widget-icon.bug {
  background: #fef3e8;
  color: #d97706;
}

.widget-value {
  font-size: 30px;
  font-weight: 800;
  color: #0A3760;
  line-height: 1.1;
}

.widget-label {
  font-size: 20px;
  font-weight: 600;
  color: #0A3760;
  line-height: 1.2;
}

/* ---------------------------
   Toolbar (Session 2)
---------------------------- */
.sum-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sum-search {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 8px 12px;
  box-shadow: var(--shadow);
}

.sum-search input {
  border: 0;
  outline: 0;
  width: 100%;
  font-size: 14px;
  background: transparent;
}

.filter-btn {
  border: 1px solid var(--border);
  background: #fff;
  color: #0A3760;
  width: 42px;
  height: 40px;
  border-radius: 10px;
  box-shadow: var(--shadow);
  cursor: pointer;
}

.filter-btn:hover {
  background: #f2f6fb;
}

/* ---------------------------
   Device Table (Session 3)
---------------------------- */
.sum-table-wrap {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  border: none;
  box-shadow: none;
}

.sum-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  border-left: 1px solid var(--border);
  border-right: 1px solid var(--border);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

/* table headers */
.sum-table thead th {
  position: sticky;
  top: 0;
  background: var(--blue-main);
  color: #fff;
  text-align: left;
  font-weight: 700;
  padding: 10px 12px;
  z-index: 1;
  white-space: nowrap;
}

.merged-header {
  text-align: center;
}

/* table cells */
.sum-table tbody td {
  padding: 6px 12px;
  border-top: 1px solid var(--border);
  vertical-align: middle;
  color: #000;
  background: transparent;
  line-height: 1.2;
}

.sum-table .wrap {
  max-width: 260px;
  white-space: normal;
}

/* alternating row background colors */
.sum-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.sum-table tbody tr:nth-child(even) {
  background-color: #f6f7fa;
}

/* Column separators same as row separators */
.colored-columns th,
.colored-columns td {
  border-right: 1px solid var(--border);
}

.colored-columns th:last-child,
.colored-columns td:last-child {
  border-right: none;
}

/* Status badges */
.status-badge {
  padding: 3px 8px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;
}

.st-online {
  background: #e7f6ec;
  color: #16a34a;
}

.st-offline {
  background: #fee2e2;
  color: #dc2626;
}

.st-maint {
  background: #fff8db;
  color: #ca8a04;
}

/* Rightmost info column */
.info-header {
  width: 40px;
  background: var(--blue-main);
}

.info-cell {
  text-align: center;
  color: #1B5D9B;
  font-size: 18px;
  cursor: pointer;
}

.info-cell:hover {
  color: #0A3760;
}

/* Pagination controls */
.sum-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}

.sum-pagination button {
  padding: 6px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-weight: 600;
  color: #000;
}

.sum-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* clickable header buttons for sorting */
.sort-btn {
  all: unset;
  cursor: pointer;
  font-weight: 700;
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.sort-btn .sort-ic {
  font-size: 14px;
}
.sort-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

/* Ensure Status column text/badge never wraps */
.sum-table td.status-cell,
.sum-table th.status-cell {
  white-space: nowrap;
}

/* Slim last info column */
.sum-table th.info-header,
.sum-table td.info-cell {
  padding-left: 1px;
  padding-right: 1px;
}

.info-cell svg {
  display: block;
  margin: 0 auto;
}

/* Info icon button */
.info-icon-btn {
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* ---------- Modal styles ---------- */
.sum-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.35);
  display: grid;
  place-items: center;
  z-index: 999;
}

.sum-modal {
  width: min(820px, 92vw);
  background: #f7fbff;
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow);
  padding: 14px 16px;
  color: #0a0a0a;
}

.sum-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.sum-modal-title {
  font-weight: 800;
  font-size: 16px;
  color: #0A3760;
}

.sum-modal-close {
  all: unset;
  cursor: pointer;
  font-size: 18px;
  color: #0A3760;
  padding: 6px;
  border-radius: 8px;
}
.sum-modal-close:hover {
  background: #e9f1fb;
}

.sum-modal-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  background: #f1f5f9;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px;
}

.sum-modal-col > div {
  margin: 6px 0;
}

.sum-modal-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.sum-btn {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #0A3760;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}
.sum-btn.ghost {
  background: #fff;
  color: #0A3760;
}
.sum-btn:hover {
  opacity: 0.95;
}

/* ---------- Filter popup customizations ---------- */
.filter-body {
  background: transparent;  /* no fill */
  border: none;             /* no border */
  box-shadow: none;
}

/* Keep checkbox + text on the same line; wrap between items only */
.sum-filter-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 12px;            /* vertical / horizontal gaps between items */
  margin-bottom: 16px;      /* space after the whole group */
}

.sum-filter-list label {
  display: inline-flex;     /* keep input + text together */
  align-items: center;
  gap: 6px;                 /* space between box and text */
  white-space: nowrap;      /* no line breaks inside a label */
  margin: 0;                /* gaps handled by container */
}

.filter-group {
  margin-bottom: 20px;      /* space below each entire group */
}

.sum-filter-title {
  font-weight: 600;
  margin-bottom: 8px;       /* space below heading */
  display: block;
}

/* ---------- Reusable white bordered action buttons ----------
   Use this class anywhere you want the same look as pagination buttons */
.action-btn,
.sum-pagination button {
  padding: 6px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-weight: 600;
  color: #000;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.action-btn:hover,
.sum-pagination button:hover {
  background: #f9fafb;
  box-shadow: 0 1px 2px rgba(0,0,0,0.06);
}

.action-btn:active,
.sum-pagination button:active {
  background: #f3f4f6;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.08);
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ============================
   NEW: Insect Top3 split view
=============================== */

/* total | type | count cells */
.it3-total {
  vertical-align: top;
  white-space: nowrap;
}

.it3-type-col > div,
.it3-count-col > div {
  line-height: 1.25;
  white-space: nowrap;
}

.it3-count-col {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* CRITICAL: Fixed height for all table rows */
.sum-table tbody tr {
  height: 50px !important; /* Use !important to override any dynamic styles */
  max-height: 50px !important;
  min-height: 50px !important;
}

.sum-table tbody td {
  padding: 6px 12px;
  border-top: 1px solid var(--border);
  vertical-align: middle;
  color: #000;
  background: transparent;
  line-height: 1.2;
  height: 50px !important;
  max-height: 50px !important;
  overflow: hidden; /* Prevent content from expanding the cell */
}

/* Ensure the top3 columns don't expand */
.it3-type-col,
.it3-count-col,
.it3-total {
  vertical-align: middle;
  height: 50px !important;
}

.it3-type-col > div,
.it3-count-col > div {
  line-height: 1.2;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/summary/Summary.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,WAAW;AACb;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,WAAW,iCAAiC;EACrD,2BAA2B,EAAE,kBAAkB;EAC/C,mBAAmB;EACnB,iBAAiB,GAAG,sBAAsB;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS,eAAe,gCAAgC;EACxD,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;8BAE8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;8BAE8B;AAC9B;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM;EACN,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mCAAmC;EACnC,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;;EAEE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA,sDAAsD;AACtD;EACE,uBAAuB,GAAG,YAAY;EACtC,YAAY,cAAc,cAAc;EACxC,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,eAAe;EACf,aAAa,aAAa,6CAA6C;EACvE,mBAAmB,OAAO,gCAAgC;AAC5D;;AAEA;EACE,oBAAoB,MAAM,+BAA+B;EACzD,mBAAmB;EACnB,QAAQ,kBAAkB,+BAA+B;EACzD,mBAAmB,OAAO,kCAAkC;EAC5D,SAAS,iBAAiB,8BAA8B;AAC1D;;AAEA;EACE,mBAAmB,OAAO,kCAAkC;AAC9D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB,QAAQ,wBAAwB;EAClD,cAAc;AAChB;;AAEA;yEACyE;AACzE;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sDAAsD;AACxD;;AAEA;;EAEE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;EAEE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iCAEiC;;AAEjC,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,uBAAuB,EAAE,kDAAkD;EAC3E,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA,yCAAyC;AACzC;;;EAGE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[":root {\n  --blue-main: #0A3760;\n  --blue-light: #1B5D9B;\n  --border: #e5e7eb;\n  --shadow: 0 4px 18px rgba(0,0,0,.06);\n}\n\n/* Page layout: sessions stacked with gap */\n.summary-page {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Row holding Session 1 & 2 side by side */\n.sum-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  align-items: stretch;\n}\n\n/* Each session container */\n.sum-section {\n  width: 100%;\n}\n\n/* Make toolbar session content align to bottom */\n.sum-section.session-toolbar {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n/* Ensure session 3 spans full width */\n.sum-section--full {\n  width: 100%;\n}\n\n/* ---------------------------\n   Widgets (Session 1)\n---------------------------- */\n.sum-widgets {\n  display: flex;\n  flex-direction: row;\n  gap: 24px;          /* narrower gap between widgets */\n  justify-content: flex-start; /* align to left */\n  align-items: center;\n  padding-left: 8px;  /* reduce left space */\n  padding-right: 0;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n\n.widget {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;              /* spacing between icon & text */\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  border-radius: 10px;\n  padding: 4px 8px;\n  text-align: left;\n  min-width: 260px;\n}\n\n.widget-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: #e9f1fb;\n  color: #0F5499;\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.widget-icon.bug {\n  background: #fef3e8;\n  color: #d97706;\n}\n\n.widget-value {\n  font-size: 30px;\n  font-weight: 800;\n  color: #0A3760;\n  line-height: 1.1;\n}\n\n.widget-label {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0A3760;\n  line-height: 1.2;\n}\n\n/* ---------------------------\n   Toolbar (Session 2)\n---------------------------- */\n.sum-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.sum-search {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 8px 12px;\n  box-shadow: var(--shadow);\n}\n\n.sum-search input {\n  border: 0;\n  outline: 0;\n  width: 100%;\n  font-size: 14px;\n  background: transparent;\n}\n\n.filter-btn {\n  border: 1px solid var(--border);\n  background: #fff;\n  color: #0A3760;\n  width: 42px;\n  height: 40px;\n  border-radius: 10px;\n  box-shadow: var(--shadow);\n  cursor: pointer;\n}\n\n.filter-btn:hover {\n  background: #f2f6fb;\n}\n\n/* ---------------------------\n   Device Table (Session 3)\n---------------------------- */\n.sum-table-wrap {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  border: none;\n  box-shadow: none;\n}\n\n.sum-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 14px;\n  border-left: 1px solid var(--border);\n  border-right: 1px solid var(--border);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n}\n\n/* table headers */\n.sum-table thead th {\n  position: sticky;\n  top: 0;\n  background: var(--blue-main);\n  color: #fff;\n  text-align: left;\n  font-weight: 700;\n  padding: 10px 12px;\n  z-index: 1;\n  white-space: nowrap;\n}\n\n.merged-header {\n  text-align: center;\n}\n\n/* table cells */\n.sum-table tbody td {\n  padding: 6px 12px;\n  border-top: 1px solid var(--border);\n  vertical-align: middle;\n  color: #000;\n  background: transparent;\n  line-height: 1.2;\n}\n\n.sum-table .wrap {\n  max-width: 260px;\n  white-space: normal;\n}\n\n/* alternating row background colors */\n.sum-table tbody tr:nth-child(odd) {\n  background-color: #ffffff;\n}\n\n.sum-table tbody tr:nth-child(even) {\n  background-color: #f6f7fa;\n}\n\n/* Column separators same as row separators */\n.colored-columns th,\n.colored-columns td {\n  border-right: 1px solid var(--border);\n}\n\n.colored-columns th:last-child,\n.colored-columns td:last-child {\n  border-right: none;\n}\n\n/* Status badges */\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-block;\n}\n\n.st-online {\n  background: #e7f6ec;\n  color: #16a34a;\n}\n\n.st-offline {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.st-maint {\n  background: #fff8db;\n  color: #ca8a04;\n}\n\n/* Rightmost info column */\n.info-header {\n  width: 40px;\n  background: var(--blue-main);\n}\n\n.info-cell {\n  text-align: center;\n  color: #1B5D9B;\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.info-cell:hover {\n  color: #0A3760;\n}\n\n/* Pagination controls */\n.sum-pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n\n.sum-pagination button {\n  padding: 6px 12px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-weight: 600;\n  color: #000;\n}\n\n.sum-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* clickable header buttons for sorting */\n.sort-btn {\n  all: unset;\n  cursor: pointer;\n  font-weight: 700;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.sort-btn .sort-ic {\n  font-size: 14px;\n}\n.sort-btn:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n/* Ensure Status column text/badge never wraps */\n.sum-table td.status-cell,\n.sum-table th.status-cell {\n  white-space: nowrap;\n}\n\n/* Slim last info column */\n.sum-table th.info-header,\n.sum-table td.info-cell {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n\n.info-cell svg {\n  display: block;\n  margin: 0 auto;\n}\n\n/* Info icon button */\n.info-icon-btn {\n  all: unset;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n/* ---------- Modal styles ---------- */\n.sum-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.35);\n  display: grid;\n  place-items: center;\n  z-index: 999;\n}\n\n.sum-modal {\n  width: min(820px, 92vw);\n  background: #f7fbff;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  box-shadow: var(--shadow);\n  padding: 14px 16px;\n  color: #0a0a0a;\n}\n\n.sum-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.sum-modal-title {\n  font-weight: 800;\n  font-size: 16px;\n  color: #0A3760;\n}\n\n.sum-modal-close {\n  all: unset;\n  cursor: pointer;\n  font-size: 18px;\n  color: #0A3760;\n  padding: 6px;\n  border-radius: 8px;\n}\n.sum-modal-close:hover {\n  background: #e9f1fb;\n}\n\n.sum-modal-body {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px;\n  background: #f1f5f9;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.sum-modal-col > div {\n  margin: 6px 0;\n}\n\n.sum-modal-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.sum-btn {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: #0A3760;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n}\n.sum-btn.ghost {\n  background: #fff;\n  color: #0A3760;\n}\n.sum-btn:hover {\n  opacity: 0.95;\n}\n\n/* ---------- Filter popup customizations ---------- */\n.filter-body {\n  background: transparent;  /* no fill */\n  border: none;             /* no border */\n  box-shadow: none;\n}\n\n/* Keep checkbox + text on the same line; wrap between items only */\n.sum-filter-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 12px;            /* vertical / horizontal gaps between items */\n  margin-bottom: 16px;      /* space after the whole group */\n}\n\n.sum-filter-list label {\n  display: inline-flex;     /* keep input + text together */\n  align-items: center;\n  gap: 6px;                 /* space between box and text */\n  white-space: nowrap;      /* no line breaks inside a label */\n  margin: 0;                /* gaps handled by container */\n}\n\n.filter-group {\n  margin-bottom: 20px;      /* space below each entire group */\n}\n\n.sum-filter-title {\n  font-weight: 600;\n  margin-bottom: 8px;       /* space below heading */\n  display: block;\n}\n\n/* ---------- Reusable white bordered action buttons ----------\n   Use this class anywhere you want the same look as pagination buttons */\n.action-btn,\n.sum-pagination button {\n  padding: 6px 12px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-weight: 600;\n  color: #000;\n  transition: background 0.2s ease, box-shadow 0.2s ease;\n}\n\n.action-btn:hover,\n.sum-pagination button:hover {\n  background: #f9fafb;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.06);\n}\n\n.action-btn:active,\n.sum-pagination button:active {\n  background: #f3f4f6;\n  box-shadow: inset 0 1px 2px rgba(0,0,0,0.08);\n}\n\n.action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ============================\n   NEW: Insect Top3 split view\n=============================== */\n\n/* total | type | count cells */\n.it3-total {\n  vertical-align: top;\n  white-space: nowrap;\n}\n\n.it3-type-col > div,\n.it3-count-col > div {\n  line-height: 1.25;\n  white-space: nowrap;\n}\n\n.it3-count-col {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n/* CRITICAL: Fixed height for all table rows */\n.sum-table tbody tr {\n  height: 50px !important; /* Use !important to override any dynamic styles */\n  max-height: 50px !important;\n  min-height: 50px !important;\n}\n\n.sum-table tbody td {\n  padding: 6px 12px;\n  border-top: 1px solid var(--border);\n  vertical-align: middle;\n  color: #000;\n  background: transparent;\n  line-height: 1.2;\n  height: 50px !important;\n  max-height: 50px !important;\n  overflow: hidden; /* Prevent content from expanding the cell */\n}\n\n/* Ensure the top3 columns don't expand */\n.it3-type-col,\n.it3-count-col,\n.it3-total {\n  vertical-align: middle;\n  height: 50px !important;\n}\n\n.it3-type-col > div,\n.it3-count-col > div {\n  line-height: 1.2;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
